import Vue from 'vue'
import InputCPFCNPJ from './CpfCnpj.vue'
import InputMoney from './Money.vue'
import InputNUmber from './Number.vue'
import Loading from '../global/Loading.vue'
import Data from './Date.vue'

Vue.component('input-cpfcnpj', InputCPFCNPJ)
Vue.component('input-number', InputNUmber)
Vue.component('input-money', InputMoney)
Vue.component('input-data', Data)
Vue.component('loader', Loading)




// WEBPACK FOOTER //
// ./src/components/inputs/Index.js